import React from "react";
import "../../css/Career.css";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import hirelocation from "../../images/hirelocation.gif";
import goal from "../../images/careerImg/goal.jpg";
import network from "../../images/careerImg/network.jpg";
import performance from "../../images/careerImg/performance.jpg";
import salary from "../../images/careerImg/salary.jpg";
import security from "../../images/careerImg/security.jpg";
import success from "../../images/careerImg/success.jpg";
import hiretalk from "../../images/hiretalk.gif";
import hiring from "../../images/hiring.png";

const Career = () => {
  const { settingsData } = useSelector((state) => state.settings);
  return (
    <>
      <Helmet>
        <title>Career - SiddhiAnanta Group</title>
        <meta
          name="description"
          content="Get in touch with SiddhiAnanta Group for JDA approved plots, budget-friendly housing, and more. Reach out to us today!"
        />
        <meta
          name="keywords"
          content="Contact SiddhiAnanta, JDA plots Jaipur, real estate contact, SiddhiAnanta Group"
        />
        <meta property="og:title" content="Career - SiddhiAnanta Group" />
        <meta
          property="og:description"
          content="We're here to help you find your dream plot. Contact SiddhiAnanta Group today."
        />
        <meta
          property="og:image"
          content="https://dreamsakha.rusofterp.in/public/webimage/setting/174591535068108dd6e4ebasid.png"
        />
        <meta
          property="og:url"
          content="https://dreamsakha.rusofterp.in/contactUs"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <section className="careerbanner-section">
        <div className="abttagline">
          <h1>WHY SiddhiAnanta Group?</h1>
          <p className="desk">
            Siddhi Ananta Group is a trusted real estate company committed to
            quality, integrity, and innovation. We offer a collaborative work
            environment that encourages learning, growth, and professional
            excellence. Our team works on impactful residential and commercial
            projects that shape modern communities. We value transparency,
            ethical practices, and long-term relationships with employees and
            clients. Career development, skill enhancement, and performance
            recognition are integral to our culture. Join Siddhi Ananta Group
            and build a rewarding career while creating spaces that matter.
          </p>
        </div>
      </section>
      <section className="contactfoot-section  sectiontopgap sectionbotgap">
        <div className="container">
          <div className="sectiontitle mb-5">
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h1>Benefits Of Working At SiddhiAnanta Group</h1>
            {/* <p className="desk">Join The Glorious Team of SiddhiAnanta Group</p>
            <p className="mob">
              Join The Glorious Team of
              <br />
              SiddhiAnanta Group
            </p> */}
          </div>

          <div className="row justify-content-center">
            <div className="benefitbx">
              <div className="benefiticon">
                <img src={success} className="img-fluid" />
              </div>
              <div>
                <h4 className="benefitText">Clear Path To Success</h4>
              </div>
            </div>
            <div className="benefitbx">
              <div className="benefiticon">
                <img src={salary} className="img-fluid" />
              </div>
              <div>
                <h4 className="benefitText">Best Salary Benchmark</h4>
              </div>
            </div>
            <div className="benefitbx">
              <div className="benefiticon">
                <img src={goal} className="img-fluid" />
              </div>
              <div>
                <h4 className="benefitText">Comprehensive Training</h4>
              </div>
            </div>
            <div className="benefitbx">
              <div className="benefiticon">
                <img src={performance} className="img-fluid" />
              </div>
              <div>
                <h4 className="benefitText">Enhanced Performance</h4>
              </div>
            </div>
            <div className="benefitbx">
              <div className="benefiticon">
                <img src={security} className="img-fluid" />
              </div>
              <div>
                <h4 className="benefitText">Job Security</h4>
              </div>
            </div>
            <div className="benefitbx">
              <div className="benefiticon">
                <img src={network} className="img-fluid" />
              </div>
              <div>
                <h4 className="benefitText">Diverse Networking</h4>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="sectiontitle mb-5">
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h1>We're Hiring!</h1>
            <p className="desk">Join The Glorious Team of SiddhiAnanta Group</p>
            <p className="mob">
              Join The Glorious Team of
              <br />
              SiddhiAnanta Group
            </p>
          </div>

          <div className="row">
            <div className="col-md-6 col-12 hiredatabx">
              <div className="hirebx">
                <div className="hireicon">
                  <img src={hirelocation} className="img-fluid" />
                </div>
                <div>
                  <h4>Our Location</h4>
                  <p>
                    <a href="#">{settingsData.address}</a>
                  </p>
                </div>
              </div>
              {/* </div>
            <div className='col-md-4 col-12'> */}
              <div className="hirebx">
                <div className="hireicon">
                  <img src={hiretalk} className="img-fluid" />
                </div>
                <div>
                  <h4>Let’s Talk</h4>
                  <p>
                    <a href={`tel:+91${settingsData?.mobile}`}>
                      +91-{settingsData.mobile}
                    </a>
                  </p>
                  <p>
                    <a href={`mailto:${settingsData?.email}`}>
                      {settingsData.email}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="hiringbx">
                <img src={hiring} className="hiringbximg" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Career;
